import React from 'react';
import styled from 'styled-components';
import { HeaderTitle } from '../../../utils/budget-tool-specific';
import SettingsList from './settings-list';

const Settings = (props) => {
    return (
        <PageContainer>
            <HeaderTitle>
                Settings
            </HeaderTitle>
            <SettingsList />
        </PageContainer>
    )
}

export default Settings;

const PageContainer = styled.div`
    padding: 30px 15px;
    height: 100%;
    box-sizing: border-box;
`;